import { render } from "./ApthPoiTypes.vue?vue&type=template&id=b6ce2728"
import script from "./ApthPoiTypes.vue?vue&type=script&lang=js"
export * from "./ApthPoiTypes.vue?vue&type=script&lang=js"

import "./ApthPoiTypes.vue?vue&type=style&index=0&id=b6ce2728&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__